import React, { useState, useEffect } from 'react';
import BookingForm from './BookingForm';

const HomeSlider = () => {

  const [showBookingForm, setShowBookingForm] = useState(false);
  
    const openBookingForm = (e) => {
      e.preventDefault();
      setShowBookingForm(true);
    };
  
    
  const [currentSlide, setCurrentSlide] = useState(0);
  const [animatedElements, setAnimatedElements] = useState({});

  const slides = [
    {
      image: "/assets/img/slider/slide-01.jpg",
      thumb: "/assets/img/slider/thumb-01.jpg",
      caption: "Women's Wear",
      title: "Luxury Suites & Rooms",
      subtitle: "Comfort and Elegance",
      animations: [
        { element: "title", effect: "fadeInDown", delay: 0 },
        { element: "subtitle", effect: "fadeInUp", delay: 800 },
        { element: "button", effect: "zoomIn", delay: 1600 }
      ]
    },
    {
      image: "/assets/img/slider/slide-02.jpg",
      thumb: "/assets/img/slider/thumb-02.jpg", 
      caption: "Men's Wear",
      title: "Unforgettable Stays",
      subtitle: "Season & Fresh Offers",
      animations: [
        { element: "title", effect: "rollIn", delay: 0 },
        { element: "subtitle", effect: "lightSpeedIn", delay: 800 },
        { element: "button", effect: "slideInUp", delay: 1600 }
      ]
    },
    {
      image: "/assets/img/slider/slide-03.jpg",
      thumb: "/assets/img/slider/thumb-03.jpg",
      caption: "Men's Wear",
      title: "Summer 2025 by the Shore",
      subtitle: "New Experiences",
      animations: [
        { element: "title", effect: "rotateInDownLeft", delay: 0 },
        { element: "subtitle", effect: "rotateInUpRight", delay: 800 },
        { element: "button", effect: "rotateIn", delay: 1600 }
      ]
    }
  ];

  useEffect(() => {
    const initialAnimations = slides[0].animations;
    
    initialAnimations.forEach((anim) => {
      setTimeout(() => {
        setAnimatedElements(prev => ({
          ...prev,
          [anim.element]: anim.effect
        }));
      }, anim.delay);
    });
  }, []); 

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [currentSlide, slides.length]);

  const goToSlide = (index) => {
    setAnimatedElements({});
    
    setTimeout(() => {
      setCurrentSlide(index);
      
      // Lancer les nouvelles animations avec leurs délais
      const currentAnimations = slides[index].animations;
      currentAnimations.forEach((anim) => {
        setTimeout(() => {
          setAnimatedElements(prev => ({
            ...prev,
            [anim.element]: anim.effect
          }));
        }, anim.delay);
      });
    }, 500);
  };

  const getAnimationClass = (elementType) => {
    return animatedElements[elementType] || '';
  };

  return ( <>
    <div style={{ position: 'relative', overflow: 'hidden' }}>
      
      <section className="section-slide">
        
        <div className="wrap-slick1 rs2-slick1">
          
          <div className="slick1">
            
            <div className="item-slick1 bg-overlay1" 
                 style={{
                   backgroundImage: `url(${slides[currentSlide].image})`,
                   backgroundSize: 'cover',
                   backgroundPosition: 'center',
                   height: '500px',
                   position: 'relative'
                 }}
                 data-thumb={slides[currentSlide].thumb}
                 data-caption={slides[currentSlide].caption}>
              
              <div className="container h-full">
                <div className="flex-col-c-m h-full p-t-100 p-b-60 respon5">
                  
                  <div className={`layer-slick1 animated ${getAnimationClass('title')}`}>
                    <span className="ltext-202 txt-center cl3 respon2">
                      {slides[currentSlide].title}
                    </span>
                  </div>
                      
                  <div className={`layer-slick1 animated ${getAnimationClass('subtitle')}`}>
                    <h2 className="ltext-104 txt-center cl3 p-t-22 p-b-40 respon1">
                      {slides[currentSlide].subtitle}
                    </h2>
                  </div>
                      
                  <div className={`layer-slick1 animated ${getAnimationClass('button')}`}>
                    {/*<a href="#test-form" className="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn2 p-lr-15 trans-04" onClick={(e) => { e.preventDefault(); setShowBookingForm(true); }} >
                      Reservation
                    </a>*/}
                    <a href="" className="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn2 p-lr-15 trans-04" >
                      Reservation
                    </a>

                  </div>
                </div>
              </div>
            </div>   
          </div>

          {/* Points de navigation */}
          <div className="wrap-slick1-dots p-lr-10" style={{ 
            position: 'absolute',
            bottom: '30px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            zIndex: 10
          }}>
            <ul style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '20px', 
              margin: '0', 
              padding: '0', 
              listStyle: 'none' 
            }}>
              {slides.map((slide, index) => (
                <li key={index} style={{ position: 'relative' }}>
                  <button
                    onClick={() => goToSlide(index)}
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '8px',
                      border: '2px solid transparent',
                      background: `url(${slide.thumb}) center/cover`,
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      ...(currentSlide === index && {
                        border: '2px solid #333',
                        transform: 'scale(1.1)'
                      })
                    }}
                    title={slide.caption}
                  >
                    {currentSlide === index && (
                      <div style={{
                        position: 'absolute',
                        bottom: '-15px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '15px',
                        height: '15px',
                        borderRadius: '50%',
                        background: '#333',
                        border: '2px solid white'
                      }} />
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
        </div>        
      </section>     
    </div>
     {showBookingForm && (
        <BookingForm onClose={() => setShowBookingForm(false)} />
      )}
      </>
  );
};

export default HomeSlider;